export const EMPTY_FILTER_OPTION = '<empty>';

const byName = (a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' });

export default {
  methods: {
    /**
     * @change handler: an emptied selection (last chip removed or the clear
     * icon) becomes null and the typed search text is dropped, so the field
     * is no longer dirty and its clear icon hides.
     * Needs `filters[key]` and `relationSearch[key]` declared in the page data.
     */
    onRelationFilterChange(key, value) {
      if (Array.isArray(value) && !value.length) {
        this.filters[key] = null;
        this.relationSearch[key] = null;
      }
    },

    /**
     * v-autocomplete :filter — "<empty>" stays visible whatever is typed,
     * other options are matched by nonDiacriticsSensitiveFilter.
     */
    relationFilterSearch(item, queryText, itemText) {
      if (itemText === EMPTY_FILTER_OPTION) return true;

      return this.nonDiacriticsSensitiveFilter(item, queryText, itemText);
    },

    /**
     * Options for a relation filter: "<empty>" first, then unique names A-Z.
     * @param {string[]} names
     * @return {string[]}
     */
    relationFilterOptions(names) {
      return [EMPTY_FILTER_OPTION, ...[...new Set(names)].sort(byName)];
    },

    /**
     * @param {string[]} selected chosen filter options
     * @param {string[]} itemValues names related to the row
     * @return {boolean} row matches when nothing is selected, when "<empty>" is
     * selected and the row has no relations, or when any selected name is related
     */
    matchRelationFilter(selected, itemValues) {
      const selectedValues = Array.isArray(selected) ? selected : [];

      if (!selectedValues.length) return true;
      if (selectedValues.includes(EMPTY_FILTER_OPTION) && !itemValues.length) return true;

      return selectedValues.some((value) => itemValues.includes(value));
    },
  },
};
